import React, {useEffect} from "react";
import PropTypes, {InferProps} from "prop-types";
import {ProjectProductListView} from "./project-product-list.view";
import {currentProject, useProject} from "@betrue/front/services";
import {usePrincipal} from "@betrue/front/profile";

export const ProjectProductListPropsTypes = {
  totalLabel: PropTypes.string,
  productListLabel: PropTypes.string,
  canDelete: PropTypes.string,
}
export type ProjectProductListProps = InferProps<typeof ProjectProductListPropsTypes>


export const ProjectProductList = (props: ProjectProductListProps) => {
  const [principal] = usePrincipal()
  const [p, , {deleteProduct}] = useProject(currentProject)

  const handleDeleteProduct = (id) => {
    deleteProduct(p.id, id)
  }

  if (!p?.id || !principal) return (<div>...</div>)

  return (
    <ProjectProductListView {...props} onDeleteProduct={handleDeleteProduct} productList={p.selectedProducts}/>
  );
}


ProjectProductList.propTypes = ProjectProductListPropsTypes
